export const getStickyTopOffset = (fallbackOffset = 130): number => {
  const appContent = document.querySelector(".App-content");
  const stickyTopValue = appContent
    ? window
        .getComputedStyle(appContent)
        .getPropertyValue("--travel-wallet-sticky-top")
    : "";
  const parsedStickyTop = Number.parseFloat(stickyTopValue);

  if (Number.isFinite(parsedStickyTop)) {
    return parsedStickyTop;
  }

  return fallbackOffset;
};
